import gql from 'graphql-tag'

import { IGeoPointInput } from './common';

export const DistanceToNearestTourQuery = gql`
	query distanceToNearestTour($where: NearestTourWhereInput!) {
		distanceToNearestTour(where: $where) 
	}
`

export interface IDistanceToNearestTourQueryVariables {
    where: IDistanceToNearestTourQueryWhereInput
}

export interface IDistanceToNearestTourQueryWhereInput {
    countryId?: number
    categories?: Array<number>
    hasCoupons?: boolean
    center: IGeoPointInput
    exclude: number[]
}

export interface IDistanceToNearestTourQueryData {
    distanceToNearestTour: number
}